"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highlightString = exports.boldString = void 0;
var _matchString = _interopRequireDefault(require("./matchString"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const highlightString = function (match, str) {
  let ignoreNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let simpleSplit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  const [parts, regex] = (0, _matchString.default)(match, str, ignoreNull, simpleSplit);
  return parts.map((part, i) => {
    // RegExp is stateful, set up a new one to work with
    const immutableRegex = new RegExp(regex);
    if (immutableRegex.exec(part) !== null) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("mark", {
        children: part
      }, i);
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: part
    }, i);
  });
};
exports.highlightString = highlightString;
const boldString = function (match, str) {
  let ignoreNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let simpleSplit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  const [parts, regex] = (0, _matchString.default)(match, str, ignoreNull, simpleSplit);
  return parts.map((part, i) => {
    // RegExp is stateful, set up a new one to work with
    const immutableRegex = new RegExp(regex);
    if (immutableRegex.exec(part) !== null) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: part
      }, i);
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: part
    }, i);
  });
};
exports.boldString = boldString;